import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react'
import { Check, Minus } from '@/components/icons'
import { cn } from '@/lib/cn'

export const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(function Checkbox({ className, ...props }, ref) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      data-slot="checkbox"
      className={cn(
        'peer inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] bg-[color:var(--card)]',
        'ring-1 ring-inset ring-[color:var(--input)] transition-colors duration-[130ms]',
        'hover:ring-[color:var(--muted-foreground)]',
        'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[color:var(--ring)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:bg-[color:var(--primary)] data-[state=checked]:text-[color:var(--primary-foreground)] data-[state=checked]:ring-[color:var(--primary)]',
        'data-[state=indeterminate]:bg-[color:var(--primary)] data-[state=indeterminate]:text-[color:var(--primary-foreground)] data-[state=indeterminate]:ring-[color:var(--primary)]',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        {props.checked === 'indeterminate' ? (
          <Minus className="size-3" weight="bold" />
        ) : (
          <Check className="size-3" weight="bold" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
